const USERS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default USERS_INITIAL_STATE
